<template>
  <div class="select-place select-start-place" ref="selectStartPlace">
    <el-popover
      popper-class="popover-select-place popover-select-start-place"
      trigger="click"
      placement="bottom-start"
      title=""
      :width="popoverWidth"
      v-model="visibleListPopover"
    >
      <div slot="reference"
      >
        <div class="text-row">
          <span v-for="(item, i) in selectValue" :key="item.id"> {{i > 0 ? ',' : ''}}{{item.goodsTypeName || ''}}</span>
        </div>
      </div>
      <div>
        <div class="product-wrap">
          <div v-if="list.length">
            <ul>
              <li :title="item.goodsTypeName" v-for="item in list" :key="item.id" :class="{isActive: slectIds && slectIds.includes(item.id)}" @click="selectProductItem(item)">{{ item.goodsTypeName }}</li>
            </ul>

            <div class="affirm-button" @click="affirm">确认</div>
          </div>
          <div v-else style="padding: 32px 0 54px 0;text-align: center;">
            <img :src="ossPath + '/pages/home/no-data.png'" alt="">
            <p style="margin-top: 33px">暂无数据</p>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {isObject,isArray,debounce} from "my-tools-kit";

export default {
  name: "selectStartPlace",
  props:{
    value:{ //选中值
      type:Array,
      default(){
        return []
      },
    },
    popoverWidth:{ //弹出层宽度
      type:String,
      default:"360",
    }
  },
  data(){
    return {
      visibleListPopover: false,
      selectValue:[], //选中的值
      list:[
        { id: 'ALL', goodsTypeName: '全部' },
        { id: 1, goodsTypeName: '普货' },
        { id: 2, goodsTypeName: '服装类' },
        { id: 3, goodsTypeName: '家具类' },
        { id: 4, goodsTypeName: '化妆品类' },
        { id: 5, goodsTypeName: '食品类' },
        { id: 6, goodsTypeName: '3C类' },
        { id: 7, goodsTypeName: '敏货类' },
        { id: 8, goodsTypeName: '其他' }
      ],
      selectedValue: []
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(newValue,oldValue){
        console.log("【selectStartPlace】监听到value变化",newValue,newValue === this.selectValue?"不处理":"处理");
        if(newValue === this.selectValue) return false;
        this.selectValue = newValue;
      }
    },
    visibleListPopover(val) {
      this.$emit(val ? 'focus' : 'blur')
      this.selectedValue = this.selectValue.map(v => v)
    }
  },
  computed: {
    slectIds() {
      return this.selectedValue.length ? this.selectedValue.map(v => v.id) : []
    }
  },
  methods:{
    /**
     * 点击/选中某条数据
     */
    clickItem(item,index){
      const data = this.selectItem(item);
      this.$refs.selectStartInput.blur();
      this.hideListPopover();
    },
    selectProductItem(item) {
      if (item.id ==='ALL') {
        return this.selectedValue = [{
          id: 'ALL',
          goodsTypeName: '全部'
        }]
      }
      const neetSet = this.selectedValue.find(v => v.id === item.id)
      if (!neetSet) {
        this.selectedValue.push(item)
      } else {
        this.selectedValue.forEach((v, i) => {
          if (v.id === item.id) this.selectedValue.splice(i, 1)
        })
      }
      if (this.selectedValue[0] && this.selectedValue[0].id === 'ALL' && this.selectedValue.length > 1) {
        this.selectedValue.splice(0, 1)
      } else if (!this.selectedValue.length) {
        this.selectedValue = [{
          id: 'ALL',
          goodsTypeName: '全部'
        }]
      }
    },
    // selectItem(item,isChange = true){
    //   let data = Object.assign({},item);
    //   this.selectValue = data;
    //   if(isChange) {
    //     this.$emit("input",data);
    //     this.$emit("change",data);
    //   }
    //   return data;
    // },
    affirm() {
      this.$emit("input", this.selectedValue)
      this.hideListPopover()
    },
    hideListPopover(e){
      this.visibleListPopover = false;
    },
    /**
     * 全局关闭
     */
    globalClosePopover(e){
      let screenDoc = this.$refs.selectStartPlace;
      if (screenDoc && !screenDoc.contains(e.target)) this.hideListPopover();
    },
  },
  created() {
    document.addEventListener("click",this.globalClosePopover,false);
  },
  destroy() {
    document.removeEventListener("click",this.globalClosePopover);
  },
}
</script>

<style scoped lang="less">
/* input和显示文本容器 */
.select-place{
  width: 100%;
  background-color: #F5F5F5;
  position: relative;
  z-index: 1;
  cursor: pointer;
}



</style>

<style lang="less">

.text-row{
  padding: 0 11px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 列表弹出层 */
.popover-select-place{
  box-sizing: border-box;
  margin-left: -27px;
  max-height: 247px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  // overflow-y: auto;
  border: none;
  &,
  &.el-popover--plain{
    padding: 0 ;
  }
  &[x-placement^="bottom"] {
    margin-top: 28px;
  }
  &[x-placement^="top"] {
    margin-bottom: 10px;
  }
  &[x-placement^="bottom"] .popper__arrow {
    left: 50px!important;
    &::after {
      top: -9px;
      border-width: 8px;
    }
  }
}
.product-wrap {
  padding: 20px;
  max-width: calc(100% - 40px);
  ul {
    display: grid;grid-template-columns: 110px 110px 110px;grid-template-rows: 35px 35px;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    li {
      box-sizing: border-box;
      padding: 0 4px;
      line-height: 28px;
      width: 100px;
      height: 28px;
      color: #141414;
      background: #EAEAEA;
      font-size: 14px;
      text-align: center;
      border-radius: 2px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      &.isActive {
        color: #FFFFFF;
        background-color: #FF4D01;
      }
    }
  }
  .affirm-button {
    margin-top: 50px;
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    background: #FF4D01;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/inquiryQueryBar/selectGoodsType.vue